import { Box, styled, Typography } from "@mui/material";
import { rem } from "polished";
import React from "react";

type Props = {
  value?: Date | null;
};

const StyledContainer = styled(Box)`
  grid-column: 2/4;
  grid-row: 1;
  padding: ${rem(16)} ${rem(24)};
`;

const StyledTitle = styled(Typography)`
  margin: 0;
  font-size: ${rem(12)};
  line-height: 2.66;
  text-transform: uppercase;
  font-weight: 400;
  color: ${(props) => props.theme.palette.datePicker.text};
`;

const StyledDate = styled(Typography)`
  margin: 0;
  font-size: ${rem(34)};
  line-height: 1.235;
  font-weight: 400;
`;

export const DatePickerToolbar = ({ value }: Props) => {
  return (
    <StyledContainer>
      <StyledTitle variant="h2">Choisir une date</StyledTitle>
      <StyledDate variant="h3">
        {value?.toLocaleDateString(undefined, { day: "numeric", month: "long" }) || "––"}
      </StyledDate>
    </StyledContainer>
  );
};
